import React from 'react'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTheme } from '@emotion/react'

// RN38/RN44: the server decides the colour by sending `status` -- this is the ONLY place that turns
// that enum into a paint colour, and it never looks at the card's own figures to do it.
const STATUS_PALETTE_KEY = {
  WARNING: 'warning',
  CRITICAL: 'error'
}

/**
 * One tile of the plan indicators ribbon (CU7): a big figure plus a supporting reading, coloured by
 * the `status` the server sent -- never computed here.
 */
const PlanIndicatorCard = ({ title, value, caption, secondaryCaption, status, testId }) => {
  const theme = useTheme()
  const paletteKey = STATUS_PALETTE_KEY[status]
  const valueColor = paletteKey ? theme.palette[paletteKey].main : theme.palette.text.primary

  return (
    <Paper variant='outlined' data-status={status} sx={{ padding: '0.75rem 1rem', minWidth: 0 }}>
      <Typography variant='caption' color='text.secondary' component='div'>
        {title}
      </Typography>
      <Typography variant='h5' component='div' data-testid={testId ? `${testId}-value` : undefined} sx={{ color: valueColor, fontWeight: 600 }}>
        {value}
      </Typography>
      {caption
        ? (
          <Typography variant='caption' color='text.secondary' component='div' data-testid={testId ? `${testId}-caption` : undefined}>
            {caption}
          </Typography>
          )
        : null}
      {secondaryCaption
        ? (
          <Typography variant='caption' color='text.secondary' component='div' data-testid={testId ? `${testId}-secondary-caption` : undefined}>
            {secondaryCaption}
          </Typography>
          )
        : null}
    </Paper>
  )
}

/**
 * The one-line reading of a card when the ribbon is folded (AP11.4): title and figure only, with the
 * figure painted by the same `status` the server sent.
 */
export const PlanIndicatorFoldedItem = ({ title, value, status, testId }) => {
  const theme = useTheme()
  const paletteKey = STATUS_PALETTE_KEY[status]
  const valueColor = paletteKey ? theme.palette[paletteKey].main : theme.palette.text.primary

  return (
    <Stack direction='row' alignItems='baseline' gap={1} data-status={status}>
      <Typography variant='caption' color='text.secondary'>{title}</Typography>
      <Typography variant='body1' data-testid={testId ? `${testId}-value` : undefined} sx={{ color: valueColor, fontWeight: 600 }}>
        {value}
      </Typography>
    </Stack>
  )
}

export default PlanIndicatorCard
